<template>
  <div class="Pages">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        pages: []
      }
    },
    computed: {

    },
    mounted () {
      this.$store.commit('ui/setPages', this.$children)
    },
    methods:{
      update () {
        this.pages = []

        this.$children.forEach((page, i) => {
          if (page.elegible) this.pages.push(page)
        })

        this.pages.forEach((page, i) => page.n = i + 1)
      }
    }
  }
</script>
